import React, { useEffect } from "react";
import AdminLayout from "../layout/AdminLayout";
import Card from "../components/Card";
import { BiUserCheck } from "react-icons/bi";
import { FaUserAltSlash } from "react-icons/fa";
import { BsPeopleFill } from "react-icons/bs";
import Header from "../components/Header";
import Chart from "react-apexcharts";
import { useDispatch, useSelector } from "react-redux";
import { getRevenue, getUserCount, getUsers } from "../redux/reducers/userSlice";
import Loader from "../components/loader/loader";

const AdminDashboard = () => {
  const dispatch = useDispatch();
  const { userCount ,revenue, users, loading} = useSelector((state) => state?.users ?? {});

  useEffect(() => {
    dispatch(getUserCount());
    dispatch(getUsers());
    dispatch(getRevenue());
  }, [dispatch]);

  useEffect(() => { 
setTimeout(() => {
      dispatch(getUserCount());
      dispatch(getUsers());
      dispatch(getRevenue());
    }, 2000);
  }, []);

  const data = [
    {
      title: "Total Users",
      value: users?.length ?? 0,
      icon: <BiUserCheck />,
      isCurrency: false,
      titleClassName: "text-red-500",
      iconClassName: " text-red-600",
    },
    {
      title: "Active Users",
      value: userCount?.activeUsers ?? 0,
      icon: <BsPeopleFill />,
      isCurrency: false,
      titleClassName: "text-green-500",
      iconClassName: " text-green-600",
    },
    {
      title: "In-Active Users",
      value: userCount?.inactiveUsers ?? 0,
      icon: <FaUserAltSlash />,
      isCurrency: false,
      titleClassName: "text-yellow-500",
      iconClassName: " text-yellow-600",
    },
  ];

  const clientStatusData = {
    series: [ userCount?.activeUsers ?? 0 , userCount?.inactiveUsers ?? 0], 
    options: {
      chart: { type: "pie", height: 350 },
      title: { text: "Client Status", align: "left" },
      labels: ["Active Clients", "Inactive Clients"],
      legend: {
        show: true,
        position: "bottom",
        horizontalAlign: "center",
      },
    },
  };

  const paymentStatusData = {
    series: [userCount?.paidUsers ?? 0, userCount?.unPaidUsers ?? 0, userCount?.trialUsers ?? 0], 
    options: {
      chart: { type: "pie", height: 350 },
      title: { text: "Payment Status", align: "left" },
      labels: ["Paid", "Un-paid", "Trial"],
      legend: {
        show: true,
        position: "bottom",
        horizontalAlign: "center",
      },
    },
  };

  const licenseFeeRevenueData = {
    series: [
      {
        name: "License Fee Revenue",
        data: [
          revenue?.revenueByMonth?.January ?? 0,
          revenue?.revenueByMonth?.February ?? 0,
          revenue?.revenueByMonth?.March ?? 0,
          revenue?.revenueByMonth?.April ?? 0,
          revenue?.revenueByMonth?.May ?? 0,
          revenue?.revenueByMonth?.June ?? 0,
          revenue?.revenueByMonth?.July ?? 0,
          revenue?.revenueByMonth?.August ?? 0,
          revenue?.revenueByMonth?.September ?? 0,
          revenue?.revenueByMonth?.October ?? 0,
          revenue?.revenueByMonth?.November ?? 0,
          revenue?.revenueByMonth?.December ?? 0
          ],
      },
    ],
    options: {
      chart: { type: "line", height: 350, toolbar: { show: true } },
      title: { text: "Current Year License Fee's Revenue", align: "left" },
      xaxis: {
        categories: [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December",
        ],
      },
      dataLabels: { enabled: false },
      stroke: { curve: "smooth" },
    },
  };

  return (
    <>
      <AdminLayout>
        <div className="p-2">
        <Loader loading={loading}  />
          <Header
            title="Dashboard"
            description="Welcome to the admin dashboard"
            subTitle="Overview"
            className="mb-8 font-bold text-xs sm:text-sm md:text-base"
          />
          <div className="flex flex-col sm:flex-row justify-evenly gap-2 space-y-2 items-center">
            {data.map((item, index) => (
              <Card
                key={index}
                title={item.title}
                value={item.value}
                icon={item.icon}
                isCurrency={item.isCurrency}
                titleClassName={`${item.titleClassName} text-xs sm:text-sm md:text-base`}
                iconClassName={`${item.iconClassName} `}
              />
            ))}
          </div>
          <div className="flex flex-col md:flex-row gap-4 p-10 w-full">
            <div className="w-full md:w-1/2 border p-5">
              <Chart
                options={clientStatusData.options}
                series={clientStatusData.series}
                type="pie"
                height={350}
              />
            </div>
            <div className="w-full md:w-1/2 border p-5">
              <Chart
                options={paymentStatusData.options}
                series={paymentStatusData.series}
                type="pie"
                height={350}
              />
            </div>
          </div>
          <div className="p-10 w-full border">
            <Chart
              options={licenseFeeRevenueData.options}
              series={licenseFeeRevenueData.series}
              type="line"
              height={350}
            />
          </div>
        </div>
      </AdminLayout>
    </>
  );
};

export default AdminDashboard;
